// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"7b3aaaad","94":"18c3e550","126":"70c14ea8","302":"5f0738db","341":"9c0c798d","565":"285f651c"}[chunkId] + ".js";
};